import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { LoftFraction } from '../../api/models';

export type TABLE_TYPE = Table<LoftFraction>;

export const TABLE = 'loftFraction';
const SCHEMA = 'loftFractionId, headTypeId, sortId'; // headTypeId index for quick lookups

class LoftFractionDatabase implements DataRepository<LoftFraction> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<LoftFraction | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: LoftFraction, key: Key): Promise<LoftFraction> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: LoftFraction[]): Promise<LoftFraction[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<LoftFraction[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const LoftFractionDB = new LoftFractionDatabase(db);
